module.exports = __webpack_public_path__ + "img/banner_450.a7ebb4c5.jpg";